<template>
  <app-base-main parentTable no-padding :hasMagin="false">
    <!-- 筛选条件 -->
    <template #filter-group>
      <app-filter-group @reset="$gjReset" :isBr="false" @query="$gjNoticeQuery">
        <gj-country-server-select
          v-model="filter.countryMarketValue"
        ></gj-country-server-select>
        <gj-select
          v-model="filter.currency"
          :options="financeCurrencysOption"
          :clearable="false"
        ></gj-select>
        <gj-select-input
            :value="filter.keyword"
            :options="keywordOptions"
          >
        </gj-select-input>
        <gj-select-date-picker-active
            :type="filter.date.key === 1 ? 'daterange' : 'monthrange'"
            v-model="filter.date"
            :options="[
              {id: 0, text: '月份'},
              {id: 1, text: '日期'},
            ]"
            :shortcuts="shortcuts"
            @input="changeDatePciker"
            :dateClearable="false"
        >
        </gj-select-date-picker-active>
        <template #advancedFilter>
          <gj-charger-select
            v-model="filter.chargeIds"
            collapse-tags
            placeholder="全部负责人"
            style="width: 150px">
          </gj-charger-select>
          <gj-category-select multiple v-model="filter.categoryIds" >
          </gj-category-select>
          <gj-brand-select v-model="filter.brandId" active>
          </gj-brand-select>
        </template>
      </app-filter-group>
    </template>
    <!-- 操作 -->
    <template #operate-group>
      <gj-button type="primary" @click="clickRecalculate">重算</gj-button>
      <gj-button type="default" @click="clickImportOtherExpenses">导入其他费用</gj-button>
      <gj-button type="default" @click="clickExpenseManagementItems">费用管理项</gj-button>
      <gj-button @click="handleAverageCost">费用分摊</gj-button>
    </template>
    <template #tool-group>
      <profit-report-tool
          :table-columns="columns" :table-name="tableName"
          download-url="/finance/financialProfitAnalysis/exportProfitAnalysis"
          :download-params="globalParams"
          :task-tip="intoCount"
      ></profit-report-tool>
    </template>
    <template #table>
      <profit-report-table-template
          adaptParent
          show-summary :summary-object="dataTotal"
          :data="data"
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          :default-sort="defaultSort"
          :queryParams="setModel()"
          :customData = "expenseManagementTable"
          :tabsActive = "'msku'"
          @refresh="$gjNoticeQuery"
      ></profit-report-table-template>
    </template>

  </app-base-main>
</template>

<script>
  import _ from "lodash";
  import ProfitReportTool from "../tool/profit-report-tool";
  import FinanceRecalculate from "@/views/modules/common/finance/finance-recalculate-modal";
  import ProfitReportTableTemplate from "./template/profit-report-table-template";
  import ImportOtherExpenses from "@/views/modules/finance/finance-profit-report/modal/import-other-expenses";
  import ExpenseManagementItems from "@/views/modules/finance/finance-profit-report/modal/expense-management-items";
  import {financeProfitReport} from '../common/fields';
  import {isMeaningfulMixin, queryMixin} from "@/minxins";
  import {exportProfitAnalysis, getFinanceAnalysisPage, queryFeeItemList, analysisStatistics, getAllProgressCount} from "@/api/finance";
  import {convertToMonth} from "@/utils/date.util";
  import { financeCurrencysOption } from "@/utils/options";
  import { startOfMonth, endOfMonth } from "date-fns";
  import {convertToFullDate} from "@/utils/date.util";
  import {isMeaningful} from "@/utils/common";

  export default {
    name: "finance-profit-report-msku",
    components: { ProfitReportTableTemplate, ProfitReportTool },
    mixins: [queryMixin, isMeaningfulMixin],
    inject: ["getFilter", "setFilter"],
    mounted() {
      let filter = this.getFilter()
      this.filter = {...this.filter, ...filter}
      let findIndex = this.keywordOptions.findIndex(item => item.id == this.filter.keyword.key)
      findIndex == -1 && ( this.filter.keyword.key = this.keywordOptions[0].id )
    },
    beforeDestroy() {
      this.setFilter(this.filter)
    },
    data() {
      return {
        financeCurrencysOption,
        isInitParams: false,
        useCache: false,
        dateKey : 0,
        tableName: 'financeProfitReportMsku_v1.8.0',
        dataTotal: {},
        data: [],
        shortcuts: [ '本月', '上月' ],
        expenseManagementTable: [],
        filter: {
          countryMarketValue: {},
          chargeIds: null, // 负责人
          categoryIds: null, // 品类
          brandId: null, // 品牌
          currency: '',
          date: {
            key: 0,
            value: new Date()- 3600 * 1000 * 24 * 30,
          },
          keyword: {
            key: 'msku',
            value: null,
          },
        },
        keywordOptions: [
          {id: 'msku', text: 'MSKU'},
          {id: 'asin', text: 'ASIN'},
          {id: 'fatherAsin', text: '父ASIN'},
          {id: 'sku', text: 'SKU'},
          {id: 'productName', text: '产品名称'},
        ],
        columns: [
          { id: "picture", header: "图片", field: "picture:imageUrl", width: "64px", default: true, disabled: true, fixed: 'left'},
          { id: "MSKU/ASIN", header: "MSKU/ASIN", field: "slot:MSKU", minWidth: "250px", default: true, fixed: 'left', disabled: true , sortable: true},
          { id: "marketName", header: "店铺/国家", field: "name", minWidth: "120px", default: true, fixed: 'left', disabled: true, sortable: true},
          { id: "crawlTitle", header: "商品标题", field: "title", minWidth: "300px", overflowLine: 2},
          { id: "skuName", header: "产品名称/SKU", field: "slot:skuName", minWidth: "150px", sortable: true,sortBy:'productName'},
          { id: "chargeNames", header: "负责人", field: "chargeNames", minWidth: "150px", overflowLine: 1},
          { id: "variationAsin", header: "父ASIN", field: "fatherAsin", minWidth: "100px", copyable: true, sortable: true},
          { id: "category", header: "品类", field: "category", minWidth: "100px"},
          { id: "brandName", header: "品牌", field: "brandName", minWidth: "90px"},
          ...financeProfitReport
        ],
        intoCount: null,
        defaultSort:{
          prop:'name,alesAmount,salesMoney',
          order:'descending,descending,descending'
        },
        moduleName: 'FINANCE_PROFIT_REPORT',
        notStorage: true
      }
    },
    watch: {
      "filter.date.key"(val) {
        if (val == 1) {
          this.shortcuts = ['今天', '昨天', '近7天', '近30天', '本月', '上月', '本年至今'];
          return;
        }
        this.shortcuts = ['本月', '上月'];
      }
    },
    created() {
      if(this.dateKey !== 1){
        this.queryFeeItemList().then(() => {
          this.$gjNoticeQuery()
        });
      } else {
        this.$gjNoticeQuery()
      }
    },
    methods: {
      getThingsCount(){
        getAllProgressCount()
          .then((data) => {
            if (isMeaningful(data) && !isNaN(data) && Number(data) !== 0) {
              this.intoCount = data;
            } else {
              this.intoCount = '';
            }
          });
      },
      // 初始化,重置
      $gjQueryInitParams() {
        return {
          filter : {
            countryMarketValue: {},
            chargeIds: null, // 负责人
            categoryIds: null, // 品类
            brandId: null, // 品牌
            currency: '',
            date: {
              key: 0,
              value: new Date()- 3600 * 1000 * 24 * 30,
            },
            keyword: {
              key: 'msku',
              value: null,
            },
          }
        }
      },
      /**
       *
       * @param params 查询条件参数
       * @override queryMixin
       * @returns {{ countryMarketValue: *}}
       */
      $gjCacheCallback(params) {
        return {
          countryMarketValue: params.countryMarketValue
        };
      },
      // 设置参数model
      setModel() {
        let model = {
          countryIds: this.filter.countryMarketValue.countryIds, // 国家
          marketIds: this.filter.countryMarketValue.marketIds, // 店铺
          currency: this.filter.currency,// 币种
          dateType: null, startDate: null, endDate: null,// 月份/日期范围
          msku: null, asin: null, fatherAsin: null, sku: null, productName: null,// MSKU/ASIN/父ASIN/SKU/产品名称
          chargeIds: this.filter.chargeIds, // 负责人
          categoryIds: this.filter.categoryIds, // 品类
          brandId: this.filter.brandId //品牌
        }
        // 月份/日期范围处理
        model.dateType = String( this.filter.date.key)
        if (this.filter.date.key === 1) {
          model.startDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM-dd');
          model.endDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM-dd');
        } else {
          model.startDate = this.filter.date.value ? convertToFullDate(this.filter.date.value, 'yyyy-MM') + '-01' : null;
          model.endDate = this.filter.date.value ? convertToFullDate(this.filter.date.value, 'yyyy-MM') + '-01' : null;
        }
        // MSKU/ASIN/父ASIN/SKU/产品名称
        model[this.filter.keyword.key] = this.filter.keyword.value;
        return model
      },
      // 查询
      $gjQuery() {
        this.getThingsCount();
        this.loading = true;
        let model = this.setModel()
        this.globalParams = {
          model,
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams.model.queryType = 'msku';
        // 获取合计
        analysisStatistics(this.globalParams).then(data => {
          this.dataTotal = data || {}
          if(this.dataTotal.feeItemList && this.dataTotal.feeItemList.length > 0){
            let feeItemList = this.dataTotal.feeItemList;
            feeItemList.forEach(o =>{
              this.dataTotal[o.feeItemName] = o.feePrice;
            })
          }
        })
        // 获取table数据
        getFinanceAnalysisPage(this.globalParams).then((data) => {
          // 自定义费用需要拿出来，放在第一级
          this.data = data.records.map((v, idx) => {
            if(v.feeItemList && v.feeItemList.length > 0){
              let feeItemList = v.feeItemList;
              feeItemList.forEach(o =>{
                v[o.feeItemName] = o.feePrice;
              })
            }
            return v;
          });
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false);
      },
      queryFeeItemList(){
        return queryFeeItemList().then((data)=>{
          let others = {
            id: 'customFee',
            header: '自定义费用',
            field: 'slot:customFee',
            align: "center",
            help: '1、站点维度添加的数据不能分摊到MSKU维度2、MSKU维度的数据需从MSKU维度添加',
            children: []
          };
          let hashList = [];
          data.forEach((v, idx) => {
            let itemExpenseManagement = {};
            const item = {
              id: `${v.feeItemName}`,
              header: v.feeItemName,
              field: `slot:${v.feeItemName}`,
              minWidth: '150px',
              align: 'right',
              prefix: 'currencySymbol',
              default: true,
              summary: true,
            }
            itemExpenseManagement = {feeItemName: v.feeItemName, canDelete: v.canDelete};
            //后端通过id判断增还是改
            if (v.id) {
              itemExpenseManagement.id = v.id;
            }
            others.children.push(item);
            hashList.push(itemExpenseManagement);
          })
          let list = _.uniqBy(hashList, 'feeItemName');
          this.expenseManagementTable = list.map(v=> v);
          let othersIndex = this.columns.findIndex(item => item.id == 'promotionOtherFee')
          this.columns.splice(othersIndex + 1, 0, others);
          //去重，防止界面多次调用此方法
          this.columns = _.uniqBy(this.columns, 'id');
          //PS 深拷贝，插入自定义数据后需要重新渲染界面
          this.columns = _.cloneDeep(this.columns);
        })
      },
      clickRecalculate() {
        const _this=this;
        this.$gjCreate(FinanceRecalculate,{
          on:{
            confirm(){
              _this.getThingsCount();
            }
          }
        })
      },
      //导入其他费用
      clickImportOtherExpenses(){
        const _this = this;
        this.$gjCreate(ImportOtherExpenses,{
          props:{
            tabsActive: "msku"
          },
          on:{
            importSuccess(cbParams){
              _this.$gjResetPage();
            },
          }
        })
      },
      //费用管理项
      clickExpenseManagementItems(){
        const _this = this;
        this.$gjCreate(ExpenseManagementItems,{
          props: {
            tableData: this.expenseManagementTable,
            tabsActive: "msku"
          },
          on:{
            imported:(params)=>{
              this.$gjMessage.success('添加成功');
              this.$gjResetPage();
            },
            cenceled:(params)=>{
              _this.queryFeeItemList().then(() => {
                this.$gjNoticeQuery()
              });
            },
          },
        })
      },
      //修改日期选择方式
      changeDatePciker(date){
        if(date.key === 1){//选择日期，隐藏自定义费用项
          if(!_.isArray(date.value)){
            this.filter.date = {
              key: 1,
              value: [startOfMonth(new Date()- 3600 * 1000 * 24 * 30), endOfMonth(new Date()- 3600 * 1000 * 24 * 30)],
            };
          }
          if(date.key !== this.dateKey){
            let othersIndex = this.columns.findIndex(item => item.id == 'promotionOtherFee')
            this.columns.splice(othersIndex + 1, 1);
          }
          this.dateKey = 1;
          this.columns = _.cloneDeep(this.columns);
        }else{
          this.filter.date = {key: date.key, value: _.isArray(date.value) ? date.value[0] : (date.value ? date.value : new Date()- 3600 * 1000 * 24 * 30),}
          this.queryFeeItemList().then(() => {
            this.$gjNoticeQuery()
          });
          this.dateKey =0;
        }
      },
      download() {
        exportProfitAnalysis(this.globalParams);
      },
      /**
       * 费用分摊弹窗
       */
      handleAverageCost () {


        let dateValue = null
        if (this.filter.date.key === 1) {
          dateValue = this.filter.date.value[1]
        } else {
          dateValue = this.filter.date.value
        }
        if (!dateValue) {
          this.$gjMessage.info('请先选择日期', '提示')
          return;
        }
        dateValue = convertToMonth(new Date(dateValue));

        this.$emit('pageBack',dateValue);

        // let modal = this.$gjCreate(CostAverageModal, {
        //   on: {
        //     cancel: () => modal.$gjDestroy(),
        //     confirm: () => {
        //
        //     }
        //   },
        //   props: {
        //     dateValue
        //   }
        // })
      }
    }
  }
</script>

<style scoped>

</style>
